import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Jckme { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ''; 
  
    @MaxLength(10) 
    CREATOR: string = ''; 
  
    @MaxLength(10) 
    USR_GROUP: string = ''; 
  
    @MaxLength(8) 
    CREATE_DATE: string =''; 
  
    @MaxLength(10) 
    MODIFIER: string = ''; 
  
    @MaxLength(8) 
    MODI_DATE: string = ''; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsEmpty({message: '不可空白'}) 
    @MaxLength(8,{message: 'ME001 資料太長'})
    ME001: string = '';            // 時間 8 HH:MM speech

    @IsEmpty({message: '不可空白'}) 
    @MaxLength(4,{message: 'ME002 資料太長'})
    ME002: string = '0001';            // 序號 4 [DEF:"0001"]

    @MaxLength(100,{message: 'ME003 資料太長'})
    ME003: string = '';            // 說明 100 

    @MaxLength(100,{message: 'ME004 資料太長'})
    ME004: string = '';            // 檔名 100 

    @MaxLength(1,{message: 'ME005 資料太長'})
    ME005: string = 'N';            // 只做一次 1 [DEF:"N"]

    @MaxLength(8,{message: 'ME006 資料太長'})
    ME006: string = '';            // 日期 8 

    @MaxLength(1,{message: 'ME010 資料太長'})
    ME010: string = 'Y';            // 周日 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME011 資料太長'})
    ME011: string = 'Y';            // 周一 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME012 資料太長'})
    ME012: string = 'Y';            // 周二 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME013 資料太長'})
    ME013: string = 'Y';            // 周三 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME014 資料太長'})
    ME014: string = 'Y';            // 周四 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME015 資料太長'})
    ME015: string = 'Y';            // 周五 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME016 資料太長'})
    ME016: string = 'Y';            // 周六 1 [DEF:"Y"]

    @MaxLength(1,{message: 'ME017 資料太長'})
    ME017: string = 'Y';            // 啟用 1 [DEF:"Y"]

    @MaxLength(10,{message: 'ME018 資料太長'})
    ME018: string = '';            // 模式 10 上班  加班 假日


}
